import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthenticatedEntry } from "./AppConfig";

const RedirectToDashboard = () => {
  const [targetPath, setTargetPath] = useState(null);

  useEffect(() => {
    const path = getAuthenticatedEntry();
    setTargetPath(path);
  }, []);

  if (!targetPath) return null; // or a loader/spinner

  return <Navigate replace to={targetPath} />;
};

export default RedirectToDashboard;